import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { elementAction, uwpAction, feedbackAction } from "../../store";
import { Keyboard } from "../control";
import { Input, Button, Checkbox } from "../elements";
import { Trans } from "react-i18next";
import Api, { CheckReportCode, CreateReportCode } from "../../api";
import { set } from "lodash";
import Uwp, { UploadFileStatusEnum } from "../../utils/uwp";
import Log from "../../utils/log";

export default function ReportCodeDialog(props) {
  const { id, t, mode } = props;
  const dispatch = useDispatch();
  const policyNoticeContentRef = useRef();
  const dialogRef = useRef(null);
  const theme = useSelector((state) => state.element.theme);
  const [confirmSubmitOtherDevice, setConfirmSubmitOtherDevice] =
    useState(false);
  const [codePass, setCodePass] = useState(false);
  const form = useSelector((state) => state.feedback.form);
  const [otpCode, setOtpCode] = useState(null);
  const reportCode = useSelector((state) => state.element.reportCode);
  const platform = useSelector((state) => state.element.platform);

  const isShowReportCodeDialog = useSelector(
    (state) => state.element.isShowReportCodeDialog
  );
  const agreePrivacyPolicy = useSelector(
    (state) => state.feedback.agreePrivacyPolicy
  );
  const privacyPolicyAbortAge = useSelector(
    (state) => state.feedback.privacyPolicyAbortAge
  );
  const privacyNotificationDialogId = useSelector(
    (state) => state.element.privacyNotificationDialogId
  );
  const geoCountry = useSelector((state) => state.feedback.geoCountry);
  const { setAgreePrivacyPolicy } = feedbackAction;

  const [focusId, setFocusId] = useState("not_agree");
  const [selected, setSelected] = useState([0, 0]);
  const [showBottomAgreeButton, setShowBottomAgreeButton] = useState(true);
  const [showPrivacyPolicyAbortAge, setShowPrivacyPolicyAbortAge] =
    useState(false);
  const [isAgreePrivacy, setIsAgreePrivacy] = useState(false);

  const dispatchDisableKeyboard = (disabled) => {
    dispatch(elementAction.setEnableRootKeyboardEvent(!disabled));
  };

  const api = new Api({
    // eslint-disable-next-line no-undef
    url: config.BACKEND_URL,
    token: "db18b1b2-d53a-4ab8-9725-c77246b65c0e",
  });

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }

    if (isShowReportCodeDialog) {
      dialog.showModal();
      dispatchDisableKeyboard(true);
    } else {
      dialog.close();
      dispatchDisableKeyboard(false);
    }
  }, [isShowReportCodeDialog]);

  useEffect(() => {
    if (showBottomAgreeButton) {
      if (privacyPolicyAbortAge === 0) {
        setFocusId("not_agree");
        setIsAgreePrivacy(true);
      } else {
        setFocusId("age");
        setIsAgreePrivacy(false);
      }
    } else {
      setFocusId("content");
      setIsAgreePrivacy(false);
    }
  }, [showBottomAgreeButton, privacyPolicyAbortAge]);

  useEffect(() => {
    if (!isAgreePrivacy) {
      dispatch(setAgreePrivacyPolicy(false));
    }
  }, [isAgreePrivacy]);

  const agreePrivacy = () => {
    dispatch(feedbackAction.setPrivacyNoticeAgreedAt());
    dispatch(feedbackAction.setAgreePrivacyPolicy(true));
    dispatch(feedbackAction.checkSubmit());
    dispatch(elementAction.triggerPrivacyNotificationDialog(false));
  };

  const disagree = () => {
    dispatch(feedbackAction.setAgreePrivacyPolicy(false));
    dispatch(elementAction.triggerDialog({ id, isOpen: false }));
  };

  const clickEnablePrivacy = () => {
    if (showBottomAgreeButton) {
      setIsAgreePrivacy(!isAgreePrivacy);
      setFocusId("not_agree");
    }
  };

  function clickPrivacyNotice() {
    dispatch(
      elementAction.triggerDialog({
        id: privacyNotificationDialogId,
        isOpen: true,
      })
    );
  }
  const isShowPrivacyNotificationDialog = useSelector(
    (state) => state.element.isShowPrivacyNotificationDialog
  );

  const options = [
    ["code"],
    ["report_code_privacy_notification"],
    ["submit_report", "cancel_report"],
  ];

  async function checkCode(code) {
    try {
      const response = await api.AuthGET(`${CheckReportCode}/${code}`);
      if (response.status === 200) {
        return response.data?.exists || false;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  useEffect(() => {
    const validateCode = async () => {
      if (!otpCode || otpCode.length !== 4) {
        setCodePass(0);
        return;
      }

      try {
        const isValid = await checkCode(otpCode);
        setCodePass(isValid ? 1 : 2);
      } catch (error) {
        setCodePass(2);
      }
    };

    validateCode();
  }, [otpCode]);

  const keyEsc = (event) => {
    event.preventDefault();
    if (mode === 0) {
      closeDialog();
    }
  };

  function closeDialog() {
    if (isShowReportCodeDialog) {
      setOtpCode(null);
      setSelected([0, 0]);
      dispatch(elementAction.setEnableRootKeyboardEvent(true));
      dispatch(elementAction.triggerReportCodeDialog(false));
    }
  }
  async function mockProcess({ percentage, speed, step = 1 }) {
    let count = 0;
    let timerId = null;
    timerId = setInterval(async function timer() {
      const _uploadFileStatus = await Uwp.getUploadLogFileStatus();
      if (_uploadFileStatus.status < UploadFileStatusEnum.PackageEnd) {
        dispatch(feedbackAction.setLogUploadProgress(count)); //  if the counter < 10, call the loop function
        count += step;
        if (count > percentage) {
          clearInterval(timerId);
        }
      } else {
        clearInterval(timerId);
      }
    }, speed);
  }
  async function syncUwpStatus() {
    const _uploadFileStatus = await Uwp.getUploadLogFileStatus();
    dispatch(uwpAction.updateUploadStatus(_uploadFileStatus));
  }
  async function createByRemoteCode(event) {
    event.preventDefault();
    dispatch(elementAction.triggerSubmitDialog(true));

    const feedbackInfo = await Uwp.getFeedbackInfo(3);
    const privacy_agreed_at =
      window.$react.store.getState().feedback.privacyNoticeAgreedAt;
    if (!Uwp.getBridge()) {
      dispatch(feedbackAction.submitFailed());
      Log.error("UWP Bridge is not ready");
    } else {
      mockProcess({
        percentage: 80,
        speed: 500,
        step: 2,
      });
      try {
        const resp = await api.POST(CreateReportCode, {
          ...{
            ...feedbackInfo,
            code: otpCode,
            platform,
            privacy_agreed_at,
          },
        });
        const { status, data } = resp;
        if (status === 200) {
          let { id } = data;
          try {
            const acceptUpload = await Uwp.uploadLogFile("report_code-" + id);
            await syncUwpStatus();
            if (acceptUpload) {
              dispatch(uwpAction.enableSync());
            } else {
              dispatch(feedbackAction.submitFailed());
              Log.error("UWP uploadLogFile return false");
            }
          } catch (e) {
            dispatch(feedbackAction.submitFailed());
          }
        } else {
          dispatch(feedbackAction.submitFailed());
          Log.error("API response status is not 200");
        }
      } catch (e) {
        dispatch(feedbackAction.submitFailed());
        Log.error("API response status is not 200", e);
      } finally {
        dispatch(elementAction.triggerSubmitDialog(true));
        dispatch(elementAction.triggerReportCodeDialog(false));
      }
    }
  }

  function confirmRemoteCode() {
    Uwp.redirectToSettingsPage();
    window.location.href = "/ac-feedback-hub";
  }

  function changeOTPCode(value) {
    if (value.length <= 4) {
      setOtpCode(value);
    }
  }

  return (
    <dialog
      ref={dialogRef}
      id={id}
      aria-labelledby={`${id}-title`}
      className="bg-transparent font-sans antialiased"
    >
      <Keyboard
        isEnabled={isShowReportCodeDialog && !isShowPrivacyNotificationDialog}
        options={options}
        selected={selected}
        setSelected={setSelected}
        keyEsc={keyEsc}
      />
      <div
        id={`${id}-overlay`}
        className={`fixed inset-0 bg-${theme} bg-opacity-80`}
      />
      <div className="w-full h-full bg-transparent relative flex justify-center items-center">
        <div
          className={`relative rounded-md w-[90vw] md:w-[70vw] lg:w-[50vw] xl:w-[40vw] h-auto bg-${theme} flex flex-col border-[1px] border-${theme}-checkbox-disabled `}
        >
          <div className={`w-full`}>
            <div className={`px-6 text-${theme}-normal`}>
              <h1 id={`${id}-title`} className="text-[16px] py-2">{t("report_code_title")}</h1>
              {mode === 0 && (
                <>
                  <div>
                    <div className={"relative px-6 py-3"}>
                      <p className="text-[16px]">
                        {t("enter_report_code_description")}
                      </p>
                      <div className="mt-10">
                        <label
                          htmlFor="code"
                          className={`text-${theme}-normal text-[16px]`}
                        >
                          {t("input_report_code_label")}
                        </label>
                        <div className="mt-[-10px]">
                          <Input
                            id={"code"}
                            type={"text"}
                            placeHolder={t("input_report_code_placeholder")}
                            errorText={t("error_report_code")}
                            formatCheck={() => {
                              return codePass !== 2;
                            }}
                            value={otpCode}
                            onChange={changeOTPCode}
                          />
                        </div>
                      </div>
                      <div className="pt-2">
                        <a
                          className="underline"
                          href={t("acse_faq_link")}
                          target="_blank"
                        >
                          {t("where_is_report_code")}
                        </a>
                      </div>
                    </div>

                    <div className="mt-10 px-5">
                      <Checkbox
                        id={"report_code_privacy_notification"}
                        label={
                          <Trans i18nKey="pp_checkbox_label">
                            <span className="underline" />
                          </Trans>
                        }
                        className={"flex max-w-full mx-5"}
                        theme={theme}
                        isFocus={false}
                        isEnabled={true}
                        isChecked={agreePrivacyPolicy}
                        onClick={clickPrivacyNotice}
                      />
                    </div>
                    <div className="flex flex-col md:flex-row w-full md:w-2/3 mt-10 ml-auto md:space-x-5 space-y-4 md:space-y-0 justify-end items-center mb-5 px-6">
                      <Button
                        role="button"
                        id={"submit_report"}
                        isFocus={(name) => false}
                        theme={theme}
                        onClick={createByRemoteCode}
                        isEnabled={codePass === 1 && agreePrivacyPolicy}
                        className={`h-[40px] min-w-[132px] max-w-[328px] text-2xl px-4 border  font-semibold relative group-hover:border-4 group-hover:border-btn-hover-light group-active:bg-btn-click group-active:border-btn-click`}
                      >
                        {t("submit")}
                      </Button>
                      <Button
                        role="button"
                        id={"cancel_report"}
                        isFocus={(name) => false}
                        theme={theme}
                        isEnabled={true}
                        onClick={closeDialog}
                        className={`h-[40px] min-w-[132px] max-w-[328px] text-2xl px-4 border font-semibold relative group-hover:border-4 group-hover:border-btn-hover-light group-active:bg-btn-click group-active:border-btn-click`}
                      >
                        {t("cancel")}
                      </Button>
                    </div>
                  </div>
                </>
              )}
              {mode === 1 && (
                <>
                  <div>
                    <div className={"relative px-6 py-3"}>
                      <p className="text-[16px]">
                        <Trans i18nKey="report_code_description">
                          <a
                            className="underline text-remote_code_link"
                            href={t("acse_faq_link")}
                            target={"new"}
                          />
                        </Trans>
                      </p>
                      <div className="mt-3 text-center text-[48px] font-bold space-x-5">
                        {reportCode.split("").map((char, index) => (
                          <span key={index}>{char}</span>
                        ))}
                      </div>
                    </div>

                    <div className="mt-5 px-5">
                      <Checkbox
                        id={"confirm_submit_other_device"}
                        label={t("confirm_submit_other_device_label")}
                        className={"flex max-w-full items-center"}
                        theme={theme}
                        isFocus={false}
                        isEnabled={true}
                        isChecked={confirmSubmitOtherDevice}
                        onClick={() =>
                          setConfirmSubmitOtherDevice(!confirmSubmitOtherDevice)
                        }
                      />
                    </div>
                    <div className="flex flex-col md:flex-row mt-10 md:space-x-5 space-y-4 md:space-y-0 justify-end items-center mb-5">
                      <Button
                        role="button"
                        id={"submit_report"}
                        isFocus={(name) => false}
                        theme={theme}
                        isEnabled={confirmSubmitOtherDevice}
                        onClick={() => {
                          confirmRemoteCode();
                        }}
                        className={`bg-${theme}-btn-disabled h-[40px] min-w-[132px] max-w-[328px] text-2xl px-4 border border-${theme}-normal font-semibold relative group-hover:border-4 group-hover:border-btn-hover-light group-active:bg-btn-click group-active:border-btn-click`}
                      >
                        {t("confirm")}
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </dialog>
  );
}
